import { useLocation } from "react-router-dom";

export default function useLocationQueryParams() {
  return new URLSearchParams(useLocation().search);
}
